import $ from 'jquery';
import 'jquery-match-height';

const thankyouScroll = () => {
	// Cache DOM
    const thankyouSection = $('.section--thank-you');
    
    if(thankyouSection.length) {
        $("html, body").animate({
            scrollTop: thankyouSection.offset().top - 70
        }, 800);
    }
};

export default thankyouScroll;
